import _ from 'lodash';
import moment from 'moment';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

//- Components
import FilterHeader from "../../components/table/FilterHeader";
import EnhancedTableHead from '../../components/table/EnhancedTableHead';

//- Helpers
import {isFiltered, sortTable, PureRecordRow} from '../../libs/tableUtilities';
import { getGlobalClasses } from '../../themes';

//- Containers
import AuthUserContainer from '../../containers/AuthUser';
import TicketSchemaContainer from '../../containers/Ticket/TicketSchema';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		table : {
			width: '100%',
			tableLayout: 'auto',
		},
	};
};

const ticketSchemaColumns = [{
	id: 'displayName',
	label: 'Ticket Schema Name',
}, {
	id: 'fieldCount',
	label: "# of Fields",
}, {
	id: 'dateCreated',
	label: 'Date Created',
}, {
	id: 'edit',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

class TicketSchemas extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'displayName',
			filter: '',
			tabIndex : 0,
			filterMap: {},
		};
	}

	componentDidMount () {
		if (!this.props.ticketSchemas.length) {
			this.props.searchTicketSchemas();
		}
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (ticketSchemaId) => {
		this.props.history.push(`/ticketSchema/update/${ticketSchemaId}`);
	};

	handleFilter = (event) => {
		this.setState({ filter : event.target.value });
	};

	render() {
		const {
			classes,
			ticketSchemas,
			permissions,
		} = this.props;

		const {
			order,
			orderBy,
			filter,
		} = this.state;

		if (!permissions || !_.includes(permissions,'canAddAndUpdateTicketSettings')) {
			return (<div>You do not have valid permissions to view this page.</div>);
		}
		if (!ticketSchemas) {
			return (<div>Fetching ticket schemas...</div>);
		}

		let ticketSchemaRows = ticketSchemas.reduce((result, ticketSchema) => {
			const {
				ticketSchemaId, displayName, dateCreated, items,
			} = ticketSchema;


			if (isFiltered({filter, row : ticketSchema, fields : ['ticketSchemaId', 'displayName']})) {
				return result;
			}

			const dateCreatedFormatted = moment(dateCreated).format('MMM Do, YYYY');

			const row = {
				ticketSchemaId, displayName,
				dateCreated, dateCreatedFormatted,
				fieldCount : items.length,
				onClick : () => this.handleEdit(ticketSchemaId),
			};
			result.push(row);
			return result;
		}, []);

		ticketSchemaRows = sortTable({ rows : ticketSchemaRows, order, orderBy});

		return (<Fragment>
				<FilterHeader
					value={this.state.filter}
					onChange={this.handleFilter}
					label={'Ticket Schemas'}
					buttonText="Add Ticket Schema"
					url="/ticketSchema/add"
					canMakeUpdates={true}
				/>

				<Paper className={classes.globalMainPaper}>
					<Table size='small' className={classes.table}>
						<EnhancedTableHead
							columns={ticketSchemaColumns}
							order={order}
							orderBy={orderBy}
							onRequestSort={this.handleSort}
						/>
						<TableBody>
							{ticketSchemaRows.map(row => {
								return (
									<PureRecordRow
										hover
										className={classes.row}
										key={row.ticketSchemaId}
									>
										<TableCell>{row.displayName}</TableCell>
										<TableCell>{row.fieldCount}</TableCell>
										<TableCell>{row.dateCreatedFormatted}</TableCell>
										<TableCell align={'center'} style={{whiteSpace:'nowrap'}}>
											<Button onClick={row.onClick}>Edit</Button>
										</TableCell>
									</PureRecordRow>
								);
							})}
						</TableBody>
					</Table>
				</Paper>
			</Fragment>
		);
	}
}

TicketSchemas.propTypes = {
	classes: PropTypes.object.isRequired,

	searchTicketSchemas: PropTypes.func.isRequired,
	ticketSchemas : PropTypes.array,

	permissions : PropTypes.array,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,
	theme: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TicketSchemaContainer,
])(TicketSchemas);